import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import API from "../services/api";

export default function LoginForm({ setToken }) {
  const [correo, setCorreo] = useState("");
  const [contrasena, setContrasena] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [showClave, setShowClave] = useState(false);
  const navigate = useNavigate();

  const botonCancelarLogin = () => {
    setCorreo("");
    setContrasena("");
    setMensaje("");
    setShowClave(false);
    navigate("/");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensaje("");

    try {
      const res = await API.post("/api/auth/login", { correo, contrasena });
      console.log("LOGIN OK:", res.data);

      const token = res?.data?.token;
      if (!token) {
        setMensaje("No se recibió token del servidor.");
        return;
      }

      localStorage.setItem("token", token);
      setToken(res.data.token);
      console.log("TOKEN GUARDADO:", localStorage.getItem("token"));

      // ✅ ahora sí te deja pasar a la ruta protegida
      navigate("/dashboard", { replace: true });
    } catch (error) {
      console.error("LOGIN ERROR:", error);
      setMensaje("Credenciales incorrectas");
    }
  };

  return (
    <div className="min-h-screen bg-[#231f2b] text-white font-nexa font-normal">
      <Navbar />

      <section className="max-w-5xl mx-auto px-6 md:px-12 py-16 space-y-12">
        <div className="flex justify-start">
          <div
            className="inline-block text-[#231f2b] font-extrabold text-2xl md:text-3xl px-8 py-4 rounded-2xl shadow-lg"
            style={{ background: "linear-gradient(90deg, #00b3b3, #00e68a)" }}
          >
            Iniciar sesión
          </div>
        </div>

        <div className="max-w-2xl">
          <form
            onSubmit={handleSubmit}
            className="relative bg-[#2c2833] p-8 rounded-2xl shadow-lg space-y-6"
          >
            <button
              type="button"
              onClick={botonCancelarLogin}
              className="absolute top-4 right-4 w-9 h-9 rounded-full bg-gray-200 text-gray-900 hover:bg-red-300 hover:text-black transition duration-300 flex items-center justify-center shadow-lg"
              title="Cancelar"
            >
              ✕
            </button>

            <p className="text-lg text-gray-300">
              El usuario debe ingresar sus credenciales para acceder a la plataforma.
            </p>

            <div>
              <label className="block text-gray-300 mb-2 font-semibold">
                Correo
              </label>
              <input
                type="text"
                value={correo}
                onChange={(e) => setCorreo(e.target.value)}
                placeholder="Correo del usuario"
                required
                className="w-full bg-transparent border-b-2 border-gray-500 focus:border-[#00e68a] outline-none py-2"
              />
            </div>

            <div>
              <label className="block text-gray-300 mb-2 font-semibold">
                Contraseña
              </label>

              <div className="relative">
                <input
                  type={showClave ? "text" : "password"}
                  value={contrasena}
                  onChange={(e) => setContrasena(e.target.value)}
                  placeholder="Contraseña del usuario"
                  required
                  className="w-full bg-transparent border-b-2 border-gray-500 focus:border-[#00e68a] outline-none py-2 pr-12"
                />

                <button
                  type="button"
                  onClick={() => setShowClave((v) => !v)}
                  className="absolute right-0 top-1/2 -translate-y-1/2 px-3 text-gray-400 hover:text-[#00e68a]"
                  tabIndex={-1}
                  aria-label="Mostrar u ocultar contraseña"
                >
                  {showClave ? "🙈" : "👁️"}
                </button>
              </div>
            </div>

            {mensaje && (
              <p className="text-red-500 text-sm font-semibold">{mensaje}</p>
            )}

            <div className="flex justify-end">
              <button
                type="submit"
                className="bg-gradient-to-r from-[#00b3b3] to-[#00e68a] text-[#231f2b] font-semibold px-10 py-3 rounded-xl mt-2 hover:scale-105 transition-transform"
              >
                Ingresar
              </button>
            </div>

            <div className="pt-2 text-sm text-gray-300 space-y-2">
              <p>
                ¿El usuario no tiene cuenta?{" "}
                <Link
                  to="/register"
                  className="text-[#00e68a] font-semibold hover:underline"
                >
                  Registrarse aquí
                </Link>
              </p>

              <p>
                ¿Requiere realizar un pago?{" "}
                <Link
                  to="/pago"
                  className="text-[#00e68a] font-semibold hover:underline"
                >
                  Ir a la sección de pagos
                </Link>
              </p>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
}
